import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPencilEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.2478 4.04505C17.1739 2.97111 15.4327 2.97111 14.3587 4.04505L13.3004 5.1034L13.2981 5.10571L13.2958 5.10803L5.2981 13.1057L5.16635 13.2374C5.09252 13.3113 5.03492 13.3997 4.99724 13.4971L3.58169 17.1546C3.03313 18.572 4.42796 19.9668 5.84536 19.4183L9.50291 18.0027C9.60028 17.9651 9.68871 17.9075 9.76254 17.8336L9.89101 17.7052L9.89429 17.7019L9.89755 17.6986L17.8943 9.7019L18.9549 8.64124C20.0289 7.5673 20.0289 5.8261 18.9549 4.75216L18.2478 4.04505ZM4.98058 17.696L6.05405 14.9223L8.07766 16.9459L5.30396 18.0194C5.10148 18.0978 4.90222 17.8985 4.98058 17.696ZM6.88908 13.636L9.36395 16.1109L16.3033 9.17158L13.8284 6.6967L6.88908 13.636ZM17.3639 8.11092L17.8943 7.58058C18.3824 7.09243 18.3824 6.30097 17.8943 5.81282L17.1872 5.10571C16.699 4.61755 15.9076 4.61755 15.4194 5.10571L14.8891 5.63605L17.3639 8.11092ZM6 20.25C5.58578 20.25 5.25 20.5858 5.25 21C5.25 21.4142 5.58578 21.75 6 21.75H18C18.4142 21.75 18.75 21.4142 18.75 21C18.75 20.5858 18.4142 20.25 18 20.25H6Z",
		fill: "currentColor"
	})
});
export { SvgIconPencilEdit as ReactComponent };
